import React from 'react'

import {Box, Theme} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

export interface ConsultationCardProps {
  children: React.ReactNode
  padding?: 'sm' | 'md' | 'lg' | string
  borderRadius?: 'sm' | 'md' | 'lg'
  backgroundColor?: string
  className?: string
}

const PADDING = {
  sm: '24px',
  md: '32px',
  lg: '64px 80px',
}

const BORDER_RADIUS = {
  sm: '8px',
  md: '12px',
  lg: '16px',
}

const useStyles = makeStyles<{
  padding: string
  borderRadius: string
  backgroundColor: string
}>()((theme: Theme, {padding, borderRadius, backgroundColor}) => ({
  card: {
    padding,
    background: backgroundColor,
    borderRadius,
    boxShadow: '0px 3px 16px rgba(190, 192, 198, 0.24)',
    width: '100%',
  },
}))

export const ConsultationCard: React.FC<ConsultationCardProps> = ({
  children,
  padding = 'md',
  borderRadius = 'lg',
  backgroundColor = '#FFFFFF',
  className,
}) => {
  const {classes} = useStyles({
    padding:
      typeof padding === 'string' && padding in PADDING
        ? PADDING[padding as keyof typeof PADDING]
        : padding,
    borderRadius: BORDER_RADIUS[borderRadius],
    backgroundColor,
  })

  return <Box className={`${classes.card} ${className || ''}`}>{children}</Box>
}
